import type { IconName } from '@/components/entities/Sprite/Icon';
import type { ModalNameType } from '@/modals/components/ModalProvider';

export type NavigationLink = {
  label: string;
  icon: IconName;
  href?: string;
  modal?: ModalNameType;
  badge?: string;
};

export const PROTECTED_LINKS: NavigationLink[] = [
  {
    label: 'Purchases',
    icon: 'purchases',
    modal: 'deposit',
  },
  {
    label: 'Redeem',
    icon: 'redeem',
    modal: 'redeem',
  },
  {
    label: 'Promotions',
    modal: 'daily-bonus',
    icon: 'promotion',
  },
  // Note: Block access to the fair-play pages.
  // After approval, when we add it to the production environment,
  // uncomment this code block and remove redirect in proxy.ts.
  // {
  //   label: 'Fair Play',
  //   icon: 'fairplay',
  //   href: '/fair-play/dashboard',
  //   badge: 'Beta',
  // },
];

export const ACCOUNT_LINKS: NavigationLink[] = [

  {
    label: 'Profile',
    href: '/profile',
    icon: 'profile',
  },

  {
    label: 'Customer Support',
    modal: 'support',
    icon: 'support-navbar',
  },
];
